import React from 'react';
import { EtiquetaDGTImgVehicleSelected, EtiquetasRowVehicleSelected } from './vehicle-section-styles';

export const VehicleEtiquetas = ({ etiquetas = [] }: { etiquetas?: string[] }) => {
	return (
		<EtiquetasRowVehicleSelected>
			{etiquetas.length > 0 && (
				<>
					{etiquetas.map((src, i) => (
						<EtiquetaDGTImgVehicleSelected key={i} src={src} alt="Etiqueta DGT" index={i} />
					))}
				</>
			)}
		</EtiquetasRowVehicleSelected>
	);
};
